import React, { useCallback } from 'react';
import AdminCrudListPage from '../../../components/admin/AdminCrudListPage';
import secteursAdminService from '../../../services/secteursAdminService';
import { ROUTES } from '../../../config/routes';

const COLUMNS = [
  {
    key: 'nom',
    label: 'Nom',
    render: (row) => <strong>{row.nom}</strong>,
  },
  {
    key: 'ville',
    label: 'Ville',
    render: (row) => row.ville || '—',
  },
  {
    key: 'secteurHubspot',
    label: 'Secteur HubSpot',
    render: (row) => row.secteurHubspot || '—',
  },
  {
    key: 'zone',
    label: 'Zone',
    getValue: (row) => row.nomZone,
    render: (row) => row.nomZone || '—',
  },
  {
    key: 'siret',
    label: 'SIRET',
    render: (row) => <small>{row.siret || '—'}</small>,
  },
];

const SecteursAdminEntreprisesPage = () => {
  const load = useCallback(async (page, q, { limit } = {}) => {
    const result = await secteursAdminService.listEntreprises({ search: q, page, limit: limit ?? 20 });
    return { rows: result.entreprises, pagination: result.pagination };
  }, []);

  return (
    <AdminCrudListPage
      title="Entreprises HubSpot"
      subtitle="Comptes clients importés depuis HubSpot"
      backTo={ROUTES.secteurs.admin}
      newTo={ROUTES.secteurs.adminEntrepriseNew}
      newLabel="Nouvelle entreprise"
      search={{
        id: 'admin-entreprises-search',
        placeholder: 'Nom, ville ou secteur HubSpot…',
      }}
      columns={COLUMNS}
      load={load}
      emptyMessage="Aucune entreprise trouvée"
      editTo={(row) => ROUTES.secteurs.adminEntrepriseEdit(row.id)}
      onDelete={(row) => secteursAdminService.deleteEntreprise(row.id)}
      deleteConfirm={{
        title: 'Supprimer cette entreprise ?',
        message: 'L’entreprise sera retirée de l’administration.',
        successMessage: 'Entreprise supprimée',
      }}
    />
  );
};

export default SecteursAdminEntreprisesPage;
